<table class="table table-hover table-striped">
  <thead>
  <tr>
    <th>{{ 'home.paycards.overview.table.head.paycardId' | translate }}</th>
    <th>{{ 'home.paycards.overview.table.head.accessId' | translate }}</th>
    <th>{{ 'home.paycards.overview.table.head.status' | translate }}</th>
    <th>{{ 'home.paycards.overview.table.head.created' | translate }}</th>
    <th>{{ 'home.paycards.overview.table.head.updated' | translate }}</th>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngIf="paycards.length > 0; else noEntries">
    <tr *ngFor="let p of paycards" (click)="onOpenDetails(p.paycardId)">
      <td>{{ p.paycardId }}</td>
      <td>{{ p.accessId ? p.accessId : '—'}}</td>
      <td>{{ p.status }}</td>
      <td>{{ p.created | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      <td>{{ p.updated | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
    </tr>
  </ng-container>
  <ng-template #noEntries>
    <tr>
      <td colspan="5">
        {{ 'home.paycards.overview.table.no-entries' | translate }}
      </td>
    </tr>
  </ng-template>
  </tbody>
</table>
